let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("8rk64")).then(() => parcelRequire('6dE10'));